import { defineComponent as _defineComponent } from 'vue'
import WidgetDefinition from '@/models/Charts/widgetDefinition';
import { WidgetEnum } from '@/models/enums/WidgetEnum';
import WidgetContainer from '@/components/Charts/widgetContainer/WidgetContainer.vue';
import { FilterTimeAxisSpanEnum } from '@/models/enums/FilterTimeAxisSpanEnum';
import { dateRangeToDateStrings } from '@/utils/dates';
import LayoutGrid from '@/views/dashboard/LayoutGrid.vue';
import { LayoutSlot } from '@/views/dashboard/layout-grid';
import { computed, shallowRef, watch } from 'vue';
import { CompositeWidgetDefinition } from '@/models/Charts/compositeWidgetDefinition';


export default /*#__PURE__*/_defineComponent({
  __name: 'DrawerInformation',
  props: {
    deviceId: null,
    dateRange: null,
    dateGrouping: null
  },
  setup(__props: any) {

const props = __props as {
  deviceId: string;
  dateRange: [Date, Date];
  dateGrouping: FilterTimeAxisSpanEnum;
};



const gridLayout: LayoutSlot[] = [
  { column: 0, row: 0, width: 8, height: 8 },
  { column: 8, row: 0, width: 4, height: 8 },
];

const stringDateRange = computed<[string, string]>(() =>
  dateRangeToDateStrings(props.dateRange),
);

const timelineChartWidgetDefinition = shallowRef<WidgetDefinition>(
  new WidgetDefinition(
    WidgetEnum.TechnologyDrawerInformationTimeline,
    props.deviceId,
    stringDateRange.value,
    [],
    undefined,
    props.dateGrouping,
  ).withIndex(0),
);

const barChartsWidgetDefinition = shallowRef<WidgetDefinition>(
  new WidgetDefinition(
    WidgetEnum.TechnologyDrawerCycleTimes,
    props.deviceId,
    stringDateRange.value,
    [],
  ).withIndex(1),
);

function onTimelineChartWidgetDefinitionChange(
  widgetDefinition: WidgetDefinition | CompositeWidgetDefinition,
) {
  timelineChartWidgetDefinition.value = widgetDefinition as WidgetDefinition;
}

watch(
  () => [props.deviceId, props.dateRange, props.dateGrouping],
  () => {
    timelineChartWidgetDefinition.value =
      timelineChartWidgetDefinition.value.getCopy({
        deviceId: props.deviceId,
        timeFilter: stringDateRange.value,
        axisSpan: props.dateGrouping,
      });

    barChartsWidgetDefinition.value = barChartsWidgetDefinition.value.getCopy({
      deviceId: props.deviceId,
      timeFilter: stringDateRange.value,
    });
  },
);

return { __sfc: true,props, gridLayout, stringDateRange, timelineChartWidgetDefinition, barChartsWidgetDefinition, onTimelineChartWidgetDefinitionChange, WidgetContainer, LayoutGrid }
}

})